import { Component, OnInit, AfterViewInit, ViewChild,OnDestroy, ElementRef, viewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ApiService } from '../../core/services/api.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import Swal from 'sweetalert2';
import * as L from 'leaflet';
import { RoleService } from '../../core/services/role.service';
import { SocketService } from '../../core/services/socket.service';
import { Subscription } from 'rxjs';

declare global {
  interface Window {
    L: any;
  }
}

@Component({
  selector: 'app-vehicle-assignment',
  templateUrl: './vehicle-assignment.component.html',
  styleUrls: ['./vehicle-assignment.component.scss'],
  standalone: false
})
export class VehicleAssignmentComponent implements OnInit, AfterViewInit, OnDestroy {
  incidentId: number | null = null;
  incident: any = null;
  fireStations: any[] = [];
  vehicles: any[] = [];
  mapVehicles: any[] = []; // Separate variable for map updates
  selectedFireStation: any = null;
  selectedVehicles: number[] = [];
  assignmentRemarks: string = '';
  loading = false;
  submitting = false;
  filteredVehicles: any[] = [];
  MediaFiles: any[] = [];
  selectedImageUrl: string | null = null;
  
  map: any;
  incidentMarker: any;
  fireStationMarkers: any[] = [];
  vehicleMarkers: any[] = [];
  locationInterval: any;
  
  // New properties for tanker selection
  tankers: any[] = [];
  selectedTanker: number | null = null;
  selectedVehicleForPopup: any = null;
  loadingTankers = false;
  
  // Properties for distance and time
  vehicleDistances: { [key: number]: { distance: number, time: number } } = {};
  loadingDistance: { [key: number]: boolean } = {};

  // Properties for quick assignment using existing vehicles
  selectedQuickVehicle: any = null;
  selectedQuickVehicles: any[] = [];
  selectedQuickTanker: any = null;
  selectedQuickTankers: any[] = [];
  quickAvailableTankers: any[] = [];
  quickAssignmentRemarks: string = '';
  isQuickAssigning = false;
  loadingQuickTankers = false;

  // Properties for assigned vehicles
  hasAssignedVehicles = false;
  assignedVehicles: any[] = [];

  // Properties for reinforcement request
  reinforcementRequest: { [key: string]: number | string } = {};
  isSubmittingReinforcement = false;
  vehicleTypes: any[] = [];
  requestSources: any[] = [];
  selectedRequestSource: any = '';
//properties for editing incident details
editData: any = {};
updatingIncident = false;
editModalRef: any;

  // Template reference for reinforcement modal
  @ViewChild('reinforcementModal') reinforcementModal: any;
  @ViewChild('editIncidentModal') editIncidentModal: any;

  // Properties for help request assignments
  helpRequestAssignments: { [key: number]: { vehicleIds: number[] } } = {};
  assigningHelpRequest = false;
  selectedHelpRequest: any = null;
  helpRequestVehicles: { [key: number]: any[] } = {};
  loadingHelpRequestVehicles: { [key: number]: boolean } = {};
  private socketSubscriptions: Subscription[] = [];

  
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private apiService: ApiService,
    private modalService: NgbModal,
    public roleService: RoleService,
    private socketService: SocketService
  ) {}

  ngOnInit(): void {
    this.incidentId = +this.route.snapshot.paramMap.get('id')!;

    if (this.incidentId) {
      this.loadIncidentData();
      this.setupSocketListeners();
    }

    // // First time load
    // this.loadVehicles();

    // Every 10 seconds refresh map only
    this.locationInterval = setInterval(() => {
      this.updateMapVehicles();
    }, 10000); // 10 sec
  }

  setupSocketListeners(): void {
    // Listen for socket events to reload local data only
    // Global notifications are handled in AppComponent
    const vehicleSub = this.socketService.onVehicleAssigned$.subscribe((data) => {
      if (data && data.incident && data.incident.id === this.incidentId) {
        // Reload incident data
        this.loadIncidentData();
      }
    });

    const crewSub = this.socketService.onCrewAssigned$.subscribe((data) => {
      if (data && data.incident && data.incident.id === this.incidentId) {
        // Reload incident data
        this.loadIncidentData();
      }
    });

    const updateSub = this.socketService.onIncidentUpdated$.subscribe((data) => {
      if (data && data.incident && data.incident.id === this.incidentId) {
        // Reload incident data
        this.loadIncidentData();
      }
    });

    this.socketSubscriptions.push(vehicleSub, crewSub, updateSub);
  }

  ngOnDestroy(): void {
    if (this.locationInterval) {
      clearInterval(this.locationInterval);
    }
    
    // Unsubscribe from all socket subscriptions
    this.socketSubscriptions.forEach(sub => sub.unsubscribe());
  }

  ngAfterViewInit(): void {
    this.initializeMap();
    
    // Make functions globally available for popup buttons
    window.selectFireStation = (stationId: number) => this.selectFireStationFromPopup(stationId);
    window.assignVehicleWithTanker = (vehicleId: number) => this.assignVehicleWithTanker(vehicleId);
  }

  private initializeMap(): void {
    // Initialize map centered on a default location (will be updated when incident loads)
    this.map = L.map('assignment-map').setView([22.7184, 75.8554], 15);
    
    // Google Maps basemap - Replace YOUR_API_KEY with your actual Google Maps API key
    L.tileLayer('https://mt1.google.com/vt/lyrs=m&x={x}&y={y}&z={z}', {
      attribution: '© Google Maps',
      maxZoom: 20,
      subdomains: ['mt0', 'mt1', 'mt2', 'mt3']
    }).addTo(this.map);
  }

  private loadIncidentData(): void {
    this.loading = true;
    
    // Load incident details
    this.apiService.get(`/incidents/${this.incidentId}`).subscribe({
      next: (response: any) => {
        this.incident = response.data || response;
        
        // Check if vehicles are already assigned
        if (this.incident.vehicleAssignments && this.incident.vehicleAssignments.length > 0) {
          this.MediaFiles = this.incident.files || [];
          this.hasAssignedVehicles = true;
          this.assignedVehicles = this.incident.vehicleAssignments;
          this.loadFireStations();
          //console.log(this.MediaFiles)
        } else {
          this.hasAssignedVehicles = false;
          this.assignedVehicles = [];
          this.loadFireStations();
          this.loadVehicles();
        }
      },
      error: (error) => {
        console.error('Error loading incident:', error);
        Swal.fire({
          icon: 'error',
          title: 'Error',
          text: 'Unable to load incident details.',
          confirmButtonColor: '#405189'
        });
        this.loading = false;
      }
    });
  }

  private loadFireStations(): void {
    this.apiService.get('/fire-stations').subscribe({
      next: (response: any) => {
        this.fireStations = response.data || response;
        this.updateMap();
        // Set loading to false if vehicles are already assigned
        if (this.hasAssignedVehicles) {
          this.loading = false;
        }
      },
      error: (error) => {
        console.error('Error loading fire stations:', error);
        if (this.hasAssignedVehicles) {
          this.loading = false;
        }
      }
    });
  }

//   private loadIncidentMedia(): void {
//     this.apiService.get(`/incidents/${this.incidentId}/files`).subscribe({
// next: (response: any) => {
//   this.MediaFiles = response.data || response || [];
//   console.log('Incident media files:', this.MediaFiles);
// },
// error: (error) => {
//   console.error('Error loading incident media files:', error);
//   this.MediaFiles = [];
// }
//     })
//   }

  private loadVehicles(): void {
    this.apiService.get('/fims-vehicles?status=available').subscribe({
      next: (response: any) => {
        this.vehicles = (response.data || response).sort((a: any, b: any) => a.fireStationId - b.fireStationId);
        this.mapVehicles = [...this.vehicles]; // Initialize map vehicles

        this.updateMap();

        this.loading = false;
      },
      error: (error) => {
        console.error('Error loading vehicles:', error);
      }
    });
  }

  private updateMapVehicles(): void {
    // Only update map vehicles, don't touch dropdown vehicles
    this.apiService.get('/fims-vehicles?status=available').subscribe({
      next: (response: any) => {
        this.mapVehicles = response.data || response;
        this.updateMap(); // Update map with new locations
      },
      error: (error) => {
        console.error('Error updating map vehicles:', error);
      }
    });
  }

  private updateMap(): void {
    if (!this.map || !this.incident) return;

    // Clear existing markers
    this.clearMarkers();

    // Add incident marker
    if (this.incident.latitude && this.incident.longitude) {
      const incidentIcon = L.divIcon({
        html: '<img src="assets/icons/incident-marker.svg" style="width: 40px; height: 40px;" alt="Incident">',
        iconSize: [40, 40],
        className: 'custom-div-icon',
        iconAnchor: [20, 20],
        popupAnchor: [0, -20]
      });

      this.incidentMarker = L.marker(
        [parseFloat(this.incident.latitude), parseFloat(this.incident.longitude)],
        { icon: incidentIcon }
      ).addTo(this.map);
      
      this.incidentMarker.bindPopup(`
        <strong>Incident: ${this.incident.incidentNo}</strong><br>
        ${this.incident.location}<br>
        Severity: ${this.incident.severity?.name}
      `);
    }

    // Add fire station markers
    this.fireStations.forEach(station => {
      if (station.latitude && station.longitude) {
        const stationIcon = L.divIcon({
          html: '<img src="assets/icons/fire-station-marker.svg" style="width: 40px; height: 40px;" alt="Fire Station">',
          iconSize: [40, 40],
          className: 'custom-div-icon',
          iconAnchor: [20, 20],
          popupAnchor: [0, -20]
        });

        const marker = L.marker(
          [parseFloat(station.latitude), parseFloat(station.longitude)],
          { icon: stationIcon }
        ).addTo(this.map);

        marker.bindPopup(`
          <strong>${station.name}</strong><br>
          ${station.address}
        `);

        this.fireStationMarkers.push(marker);
      }
    });

    // Add free vehicle markers
    this.mapVehicles.forEach(vehicle => {
      if (vehicle.lastLocation?.lat && vehicle.lastLocation?.lng) {
        const vehicleIcon = L.divIcon({
          html: '<img src="assets/icons/vehicle-marker.svg" style="width: 36px; height: 36px;" alt="Vehicle">',
          iconSize: [36, 36],
          className: 'custom-div-icon',
          iconAnchor: [18, 18],
          popupAnchor: [0, -18]
        });

        const marker = L.marker(
          [parseFloat(vehicle.lastLocation.lat), parseFloat(vehicle.lastLocation.lng)],
          { icon: vehicleIcon }
        ).addTo(this.map);

        // Create enhanced popup with tanker dropdown and distance info
        const popupContent = `
          <div style="min-width: 280px;">
            <h6 style="margin-bottom: 10px; color: #B71C1C;">${vehicle.vehicleNo}</h6>
            <p style="margin: 5px 0;"><strong>Type:</strong> ${vehicle.vehicleType}</p>
             <p style="margin: 5px 0;"><strong>Firestation:</strong> ${ this.getFireStationName(vehicle.fireStationId)}</p>
            <p style="margin: 5px 0;"><strong>Make:</strong> ${vehicle.make}</p>
            <p style="margin: 5px 0;"><strong>Model:</strong> ${vehicle.model}</p>
            <p style="margin: 5px 0;"><strong>Capacity:</strong> ${vehicle.capacity}L</p>
            <p style="margin: 5px 0;"><strong>Speed:</strong> ${vehicle.lastLocation.speed} km/h</p>
            <p style="margin: 5px 0;"><strong>Ignition:</strong> ${vehicle.lastLocation.ignitionStatus === 1 ? 'On' : 'Off'}</p>
            
            <div style="margin-top: 15px; padding-top: 15px; border-top: 1px solid #ddd;">
              <p style="margin: 5px 0; font-weight: bold; color: #B71C1C;">Distance to Incident:</p>
              <div id="distance-${vehicle.id}" style="margin: 5px 0; color: #666;">Loading distance...</div>
              
              <label style="display: block; margin-bottom: 5px; font-weight: bold; margin-top: 10px;">Select Tanker:</label>
              <select id="tanker-select-${vehicle.id}" style="width: 100%; padding: 5px; margin-bottom: 10px; border: 1px solid #ddd; border-radius: 4px;">
                <option value="">Loading tankers...</option>
              </select>
              <button onclick="window.assignVehicleWithTanker(${vehicle.id})" 
                      style="background-color: #B71C1C; color: white; border: none; padding: 8px 16px; border-radius: 4px; cursor: pointer; width: 100%;">
                Assign Vehicle & Tanker
              </button>
            </div>
          </div>
        `;

        marker.bindPopup(popupContent);
        
        // Load tankers and distance when popup is opened
        marker.on('popupopen', () => {
          this.loadTankersForVehicle(vehicle);
          this.fetchDistanceAndTime(vehicle.id);
          
          // Update distance display when data is available
          const updateDistanceDisplay = () => {
            const distanceElement = document.getElementById(`distance-${vehicle.id}`);
            if (distanceElement) {
              if (this.loadingDistance[vehicle.id]) {
                distanceElement.innerHTML = '<span style="color: #666;">Loading distance...</span>';
              } else if (this.vehicleDistances[vehicle.id]) {
                const distance = this.vehicleDistances[vehicle.id].distance;
                const time = this.vehicleDistances[vehicle.id].time;
                distanceElement.innerHTML = `
                  <div style="color: #333;">
                    <strong>Distance:</strong> ${distance.toFixed(2)} km<br>
                    <strong>Est. Time:</strong> ${time} minutes
                  </div>
                `;
              } else {
                distanceElement.innerHTML = '<span style="color: #999;">Distance unavailable</span>';
              }
            }
          };
          
          // Initial update
          updateDistanceDisplay();
          
          // Watch for changes in distance data
          const checkInterval = setInterval(() => {
            if (!this.loadingDistance[vehicle.id]) {
              updateDistanceDisplay();
              clearInterval(checkInterval);
            }
          }, 500);
        });

        this.vehicleMarkers.push(marker);
      }
    });

    // Add assigned vehicle markers
    if (this.hasAssignedVehicles && this.assignedVehicles.length > 0) {
      this.assignedVehicles.forEach(assignment => {
        const vehicle = assignment.vehicle;
        
        // Create assigned vehicle icon (green color to distinguish from free vehicles)
        const assignedVehicleIcon = L.divIcon({
          html: '<div style="background-color: #28a745; border: 2px solid white; border-radius: 50%; width: 36px; height: 36px; display: flex; align-items: center; justify-content: center; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"><i class="ri-truck-line" style="color: white; font-size: 20px;"></i></div>',
          iconSize: [36, 36],
          className: 'custom-div-icon',
          iconAnchor: [18, 18],
          popupAnchor: [0, -18]
        });

        // Use fire station location as vehicle location if vehicle location is not available
        const lat = vehicle.lastLocation?.lat || assignment.fireStation.latitude;
        const lng = vehicle.lastLocation?.lng || assignment.fireStation.longitude;
        
        if (lat && lng) {
          const marker = L.marker(
            [parseFloat(lat), parseFloat(lng)],
            { icon: assignedVehicleIcon }
          ).addTo(this.map);

          // Create popup for assigned vehicle
          const popupContent = `
            <div style="min-width: 280px;">
              <h6 style="margin-bottom: 10px; color: #28a745;">${vehicle.vehicleNo} (Assigned)</h6>
              <p style="margin: 5px 0;"><strong>Type:</strong> ${vehicle.vehicleType}</p>
              <p style="margin: 5px 0;"><strong>Make:</strong> ${vehicle.make}</p>
              <p style="margin: 5px 0;"><strong>Model:</strong> ${vehicle.model}</p>
              <p style="margin: 5px 0;"><strong>Capacity:</strong> ${vehicle.capacity}L</p>
              <p style="margin: 5px 0;"><strong>Station:</strong> ${assignment.fireStation.name}</p>
              <p style="margin: 5px 0;"><strong>Status:</strong> <span style="color: #28a745; font-weight: bold;">${assignment.status.charAt(0).toUpperCase() + assignment.status.slice(1)}</span></p>
              <p style="margin: 5px 0;"><strong>Assigned At:</strong> ${this.formatDate(assignment.assignedAt)}</p>
              ${assignment.remarks ? `<p style="margin: 5px 0;"><strong>Remarks:</strong> ${assignment.remarks}</p>` : ''}
            </div>
          `;

          marker.bindPopup(popupContent);
          this.vehicleMarkers.push(marker);
        }
      });
    }

    // Fit map to show all markers
    if (this.incidentMarker || this.fireStationMarkers.length > 0) {
      const group = new L.FeatureGroup([
        this.incidentMarker,
        ...this.fireStationMarkers,
        ...this.vehicleMarkers
      ].filter(Boolean));
      
      this.map.fitBounds(group.getBounds().pad(0.1));
    }
  }

  private clearMarkers(): void {
    if (this.incidentMarker) {
      this.map.removeLayer(this.incidentMarker);
    }
    this.fireStationMarkers.forEach(marker => this.map.removeLayer(marker));
    this.vehicleMarkers.forEach(marker => this.map.removeLayer(marker));
    this.fireStationMarkers = [];
    this.vehicleMarkers = [];
  }

  selectFireStation(station: any): void {
    this.selectedFireStation = station;
    
    // Show all vehicles regardless of fire station selection
    this.filteredVehicles = this.vehicles;
    
    // Clear vehicle selection when fire station changes
    this.updateVehicleSelection();
  }

  onVehicleSelectionChange(vehicleId: number, event: any): void {
    if (event.target.checked) {
      if (!this.selectedVehicles.includes(vehicleId)) {
        this.selectedVehicles.push(vehicleId);
      }
    } else {
      const index = this.selectedVehicles.indexOf(vehicleId);
      if (index > -1) {
        this.selectedVehicles.splice(index, 1);
      }
    }
  }

  private updateVehicleSelection(): void {
    // Clear selection when fire station changes
    this.selectedVehicles = [];
  }

  goBack(): void {
    this.router.navigate(['/incidents']);
  }

  // Method to fetch distance and time for a vehicle
  fetchDistanceAndTime(vehicleId: number): void {
    if (!this.incidentId || this.loadingDistance[vehicleId]) {
      return;
    }

    this.loadingDistance[vehicleId] = true;

    this.apiService.get(`/distance-to-incident/${vehicleId}/${this.incidentId}`).subscribe({
      next: (response: any) => {
        this.loadingDistance[vehicleId] = false;
        console.log('Distance API Response:', response);
        
        if (response.success && response.data) {
          // Convert distance from meters to kilometers
          const distanceInKm = response.data.distance.value / 1000;
          // Convert duration from seconds to minutes
          const timeInMinutes = Math.round(response.data.duration.value / 60);
          
          this.vehicleDistances[vehicleId] = {
            distance: distanceInKm,
            time: timeInMinutes
          };
          
          console.log(`Vehicle ${vehicleId} - Distance: ${distanceInKm.toFixed(2)} km, Time: ${timeInMinutes} mins`);
        } else {
          console.warn('Invalid response structure:', response);
          this.vehicleDistances[vehicleId] = {
            distance: 0,
            time: 0
          };
        }
      },
      error: (error) => {
        this.loadingDistance[vehicleId] = false;
        console.error('Error fetching distance:', error);
        // Set default values on error
        this.vehicleDistances[vehicleId] = {
          distance: 0,
          time: 0
        };
      }
    });
  }


  // Load tankers for a specific vehicle based on its fire station
  private loadTankersForVehicle(vehicle: any, isQuickAssignment: boolean = false): void {
    this.selectedVehicleForPopup = vehicle;
    
    if (isQuickAssignment) {
      this.loadingQuickTankers = true;
    } else {
      this.loadingTankers = true;
    }
    // &fire_station_id=${vehicle.fireStationId}
    const apiUrl = `/vehicles/free?vehicle_type=tanker`;
    
    this.apiService.get(apiUrl).subscribe({
      next: (response: any) => {
        const tankersData = response.data || response;
        
        if (isQuickAssignment) {
          this.quickAvailableTankers = tankersData;
          this.loadingQuickTankers = false;
        } else {
          this.tankers = tankersData;
          this.loadingTankers = false;
          this.updateTankerDropdown(vehicle.id);
        }
      },
      error: (error) => {
        console.error('Error loading tankers:', error);
        
        if (isQuickAssignment) {
          this.quickAvailableTankers = [];
          this.loadingQuickTankers = false;
        } else {
          this.loadingTankers = false;
          this.updateTankerDropdown(vehicle.id, true);
        }
      }
    });
  }

  // Update the tanker dropdown in the popup
  private updateTankerDropdown(vehicleId: number, hasError: boolean = false): void {
    const selectElement = document.getElementById(`tanker-select-${vehicleId}`) as HTMLSelectElement;
    if (selectElement) {
      selectElement.innerHTML = '';
      
      if (hasError) {
        const option = document.createElement('option');
        option.value = '';
        option.textContent = 'Error loading tankers';
        selectElement.appendChild(option);
      } else if (this.tankers.length === 0) {
        const option = document.createElement('option');
        option.value = '';
        option.textContent = 'No tankers available';
        selectElement.appendChild(option);
      } else {
        const defaultOption = document.createElement('option');
        defaultOption.value = '';
        defaultOption.textContent = 'Select a tanker';
        selectElement.appendChild(defaultOption);
        
        this.tankers.forEach(tanker => {
          const option = document.createElement('option');
          option.value = tanker.id.toString();
          option.textContent = `${tanker.vehicleNo} - ${tanker.make} ${tanker.model} (${tanker.capacity}L)`;
          selectElement.appendChild(option);
        });
      }
    }
  }

  // Handle vehicle assignment with tanker selection
  assignVehicleWithTanker(vehicleId: number): void {
    const selectElement = document.getElementById(`tanker-select-${vehicleId}`) as HTMLSelectElement;
    const tankerId = selectElement?.value;
    
    if (!tankerId) {
      Swal.fire({
        icon: 'warning',
        title: 'No Tanker Selected',
        text: 'Please select a tanker before proceeding.',
        confirmButtonColor: '#B71C1C'
      });
      return;
    }
    
    const vehicle = this.vehicles.find(v => v.id === vehicleId);
    if (!vehicle) {
      Swal.fire({
        icon: 'error',
        title: 'Vehicle Not Found',
        text: 'Unable to find the selected vehicle.',
        confirmButtonColor: '#B71C1C'
      });
      return;
    }
    
    // Find the fire station for this vehicle
    const fireStation = this.fireStations.find(fs => fs.id === vehicle.fireStationId);
    if (!fireStation) {
      Swal.fire({
        icon: 'error',
        title: 'Fire Station Not Found',
        text: 'Unable to find the fire station for this vehicle.',
        confirmButtonColor: '#B71C1C'
      });
      return;
    }
    
    // Assign the fire station
    this.selectedFireStation = fireStation;
    
    // Prepare vehicle IDs array (vehicle + tanker)
    const vehicleIds = [vehicleId, parseInt(tankerId)];
    
    this.submitting = true;
    
    const assignmentData = {
      incidentId: this.incidentId,
      fireStationId: fireStation.id,
      vehicleIds: vehicleIds,
      remarks: this.assignmentRemarks || `Dispatching vehicle ${vehicle.vehicleNo} with tanker from ${fireStation.name}`
    };
    
    this.apiService.post('/incidents/assign-vehicles', assignmentData).subscribe({
      next: (response: any) => {
        this.submitting = false;
        Swal.fire({
          icon: 'success',
          title: 'Vehicle & Tanker Assigned Successfully!',
          text: `Vehicle ${vehicle.vehicleNo} and selected tanker have been assigned to incident ${this.incident?.incidentNo}.`,
          confirmButtonColor: '#B71C1C'
        }).then(() => {
          // Reload incident data to show assigned vehicles
          this.loadIncidentData();
        });
      },
      error: (error) => {
        this.submitting = false;
        console.error('Error assigning vehicles:', error);
        Swal.fire({
          icon: 'error',
          title: 'Assignment Failed',
          text: 'Failed to assign vehicle and tanker. Please try again.',
          confirmButtonColor: '#B71C1C'
        });
      }
    });
  }

  // Make this method available globally for popup buttons
  selectFireStationFromPopup(stationId: number): void {
    const station = this.fireStations.find(s => s.id === stationId);
    if (station) {
      this.selectFireStation(station);
    }
  }

  getStatusBadgeClass(status: string): string {
    switch (status?.toLowerCase()) {
      case 'reported':
        return 'bg-warning';
      case 'dispatched':
        return 'bg-info';
      case 'in_progress':
        return 'bg-primary';
      case 'resolved':
        return 'bg-success';
      case 'closed':
        return 'bg-secondary';
      default:
        return 'bg-secondary';
    }
  }

  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    
    try {
      const date = new Date(dateString);
      return date.toLocaleString('en-US', {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        hour: '2-digit',
        minute: '2-digit'
      });
    } catch (error) {
      return 'N/A';
    }
  }

  // Quick Assignment Methods using existing vehicles data
  getFireStationName(fireStationId: number): string {
    const station = this.fireStations.find(s => s.id === fireStationId);
    return station ? station.name : 'Unknown Station';
  }

  onQuickVehicleSelectionChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const vehicleId = target.value;
    
    if (!vehicleId) {
      this.selectedQuickVehicle = null;
      this.selectedQuickTanker = null;
      this.quickAvailableTankers = [];
      return;
    }

    this.selectedQuickVehicle = this.vehicles.find(v => v.id === parseInt(vehicleId));
    this.selectedQuickTanker = null;
    this.quickAvailableTankers = [];

    if (this.selectedQuickVehicle) {
      this.loadTankersForVehicle(this.selectedQuickVehicle, true);
    }
  }

  onQuickTankerSelectionChange(event: Event): void {
    const target = event.target as HTMLSelectElement;
    const tankerId = target.value;
    
    if (!tankerId) {
      this.selectedQuickTanker = null;
      return;
    }

    this.selectedQuickTanker = this.quickAvailableTankers.find(t => t.id === parseInt(tankerId));
  }



  isQuickVehicleAlreadyAssigned(vehicleId: number): boolean {
    // Check if vehicle is already assigned by looking at selectedVehicles array
    return this.selectedVehicles.includes(vehicleId);
  }

  isQuickVehicleSelected(vehicleId: number): boolean {
    return this.selectedQuickVehicles.some(v => v.id === vehicleId);
  }

  toggleQuickVehicleSelection(vehicleId: number): void {
    const vehicle = this.vehicles.find(v => v.id === vehicleId);
    if (!vehicle) return;

    const index = this.selectedQuickVehicles.findIndex(v => v.id === vehicleId);
    if (index > -1) {
      // Remove vehicle from selection
      this.selectedQuickVehicles.splice(index, 1);
      
      // If this was the only vehicle, reset tanker selection
      if (this.selectedQuickVehicles.length === 0) {
        this.selectedQuickTanker = null;
        this.selectedQuickTankers = [];
        this.quickAvailableTankers = [];
      }
    } else {
      // Add vehicle to selection
      this.selectedQuickVehicles.push(vehicle);
      
      // Load tankers for the first selected vehicle (or refresh if different station)
      if (this.selectedQuickVehicles.length === 1) {
        this.loadTankersForVehicle(vehicle, true);
      }
    }
  }

  isQuickTankerSelected(tankerId: number): boolean {
    return this.selectedQuickTankers.some(t => t.id === tankerId);
  }

  toggleQuickTankerSelection(tankerId: number): void {
    const tanker = this.quickAvailableTankers.find(t => t.id === tankerId);
    if (!tanker) return;

    const index = this.selectedQuickTankers.findIndex(t => t.id === tankerId);
    if (index > -1) {
      // Remove tanker from selection
      this.selectedQuickTankers.splice(index, 1);
    } else {
      // Add tanker to selection
      this.selectedQuickTankers.push(tanker);
    }
  }

  assignQuickVehiclesWithTanker(): void {
    if (this.selectedQuickVehicles.length === 0) return;

    // Check if any selected vehicles are already assigned
    const alreadyAssigned = this.selectedQuickVehicles.filter(v => this.isQuickVehicleAlreadyAssigned(v.id));
    if (alreadyAssigned.length > 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Some Vehicles Already Assigned',
        text: `${alreadyAssigned.map(v => v.vehicleNo).join(', ')} are already assigned to this incident.`,
        confirmButtonColor: '#B71C1C'
      });
      return;
    }

    this.isQuickAssigning = true;

    const vehicleIds = this.selectedQuickVehicles.map(v => v.id);
    const tankerIds = this.selectedQuickTankers.map(t => t.id);
    const allVehicleIds = [...vehicleIds, ...tankerIds];

    const vehicleNames = this.selectedQuickVehicles.map(v => v.vehicleNo).join(', ');
    const defaultRemarks = this.selectedQuickTankers.length > 0
      ? `Quick assignment of ${vehicleNames} with tankers: ${this.selectedQuickTankers.map(t => t.vehicleNo).join(', ')}`
      : `Quick assignment of ${vehicleNames}`;

    const assignmentData = {
      incidentId: this.incidentId,
      fireStationId: this.selectedQuickVehicles[0].fireStationId, // Use first vehicle's station
      vehicleIds: allVehicleIds,
      remarks: this.quickAssignmentRemarks || defaultRemarks
    };

    this.apiService.post('/incidents/assign-vehicles', assignmentData).subscribe({
      next: (response: any) => {
        let message = `${vehicleNames} have been successfully assigned to the incident.`;
        if (this.selectedQuickTankers.length > 0) {
          const tankerNames = this.selectedQuickTankers.map(t => t.vehicleNo).join(', ');
          message += ` Tankers: ${tankerNames} were also assigned.`;
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Vehicles Assigned',
          text: message,
          confirmButtonColor: '#B71C1C'
        });
        
        // Reset form
        this.selectedQuickVehicle = null;
        this.selectedQuickVehicles = [];
        this.selectedQuickTanker = null;
        this.selectedQuickTankers = [];
        this.quickAvailableTankers = [];
        this.quickAssignmentRemarks = '';
        
        // Reload incident data to show assigned vehicles
        this.loadIncidentData();
      },
      error: (error) => {
        console.error('Error assigning vehicles:', error);
        Swal.fire({
          icon: 'error',
          title: 'Assignment Failed',
          text: 'Failed to assign vehicles. Please try again.',
          confirmButtonColor: '#B71C1C'
        });
      },
      complete: () => {
        this.isQuickAssigning = false;
      }
    });
  }

  assignQuickVehicleWithTanker(): void {
    if (!this.selectedQuickVehicle) return;

    if (this.isQuickVehicleAlreadyAssigned(this.selectedQuickVehicle.id)) {
      Swal.fire({
        icon: 'warning',
        title: 'Already Assigned',
        text: 'This vehicle is already assigned to this incident.',
        confirmButtonColor: '#B71C1C'
      });
      return;
    }

    this.isQuickAssigning = true;

    const vehicleIds = [this.selectedQuickVehicle.id];
    if (this.selectedQuickTanker) {
      vehicleIds.push(this.selectedQuickTanker.id);
    }

    const defaultRemarks = this.selectedQuickTanker
      ? `Quick assignment of ${this.selectedQuickVehicle.vehicleNo} with tanker ${this.selectedQuickTanker.vehicleNo}`
      : `Quick assignment of ${this.selectedQuickVehicle.vehicleNo}`;

    const assignmentData = {
      incidentId: this.incidentId,
      fireStationId: this.selectedQuickVehicle.fireStationId,
      vehicleIds: vehicleIds,
      remarks: this.quickAssignmentRemarks || defaultRemarks
    };

    this.apiService.post('/incidents/assign-vehicles', assignmentData).subscribe({
      next: (response: any) => {
        const message = this.selectedQuickTanker 
          ? `${this.selectedQuickVehicle.vehicleNo} and tanker ${this.selectedQuickTanker.vehicleNo} have been successfully assigned to the incident.`
          : `${this.selectedQuickVehicle.vehicleNo} has been successfully assigned to the incident.`;
        
        Swal.fire({
          icon: 'success',
          title: 'Vehicle Assigned',
          text: message,
          confirmButtonColor: '#B71C1C'
        });
        
        // Reset form
        this.selectedQuickVehicle = null;
        this.selectedQuickTanker = null;
        this.quickAvailableTankers = [];
        this.quickAssignmentRemarks = '';
        
        // Reload incident data to show assigned vehicles
        this.loadIncidentData();
        
        this.isQuickAssigning = false;
      },
      error: (error) => {
        console.error('Error in quick assignment:', error);
        Swal.fire({
          icon: 'error',
          title: 'Assignment Failed',
          text: 'Failed to assign the vehicle. Please try again.',
          confirmButtonColor: '#B71C1C'
        });
        this.isQuickAssigning = false;
      }
    });
  }

  // Reinforcement Request Methods
  loadVehicleTypes(): void {
    this.apiService.get('/static/vehicle-types').subscribe({
      next: (response: any) => {
        this.vehicleTypes = (response.data || response).filter((item :any )=>  item.value === 'firebrigade' || item.value === 'water_tanker' );
        // Initialize reinforcement request object with vehicle types from API
        this.initializeReinforcementRequest();
      },
      error: (error) => {
        console.error('Error loading vehicle types:', error);
      }
    });
  }

  loadRequestSources(): void {
    this.apiService.get('/static/request-sources').subscribe({
      next: (response: any) => {
        this.requestSources = response.data || response;
      },
      error: (error) => {
        console.error('Error loading request sources:', error);
      }
    });
  }

  initializeReinforcementRequest(): void {
    this.reinforcementRequest = {};
    this.vehicleTypes.forEach(vehicleType => {
      this.reinforcementRequest[vehicleType.value] = 0;
    });
    this.reinforcementRequest['remarks'] = '';
  }

  handleReinforcementRequest(): void {
    // Load static data if not already loaded
    if (this.vehicleTypes.length === 0) {
      this.loadVehicleTypes();
    }
    if (this.requestSources.length === 0) {
      this.loadRequestSources();
    }

    // Open modal using NgbModal
    this.modalService.open(this.reinforcementModal, { 
      size: 'lg',
      centered: true,
      backdrop: 'static'
    });
  }

  incrementVehicleCount(type: string): void {
    const currentValue = this.reinforcementRequest[type] as number;
    if (currentValue < 10) {
      this.reinforcementRequest[type] = currentValue + 1;
    }
  }

  decrementVehicleCount(type: string): void {
    const currentValue = this.reinforcementRequest[type] as number;
    if (currentValue > 0) {
      this.reinforcementRequest[type] = currentValue - 1;
    }
  }

  validateVehicleCount(type: string): void {
    const currentValue = this.reinforcementRequest[type] as number;
    if (currentValue < 0) {
      this.reinforcementRequest[type] = 0;
    } else if (currentValue > 10) {
      this.reinforcementRequest[type] = 10;
    }
  }

  getTotalRequestedVehicles(): number {
    let total = 0;
    Object.keys(this.reinforcementRequest).forEach(key => {
      if (key !== 'remarks') {
        total += this.reinforcementRequest[key] as number;
      }
    });
    return total;
  }

  isDecrementDisabled(vehicleType: string): boolean {
    const value = Number(this.reinforcementRequest[vehicleType] || 0);
    return value === 0;
  }

  isIncrementDisabled(vehicleType: string): boolean {
    const value = Number(this.reinforcementRequest[vehicleType] || 0);
    return value >= 10;
  }

  // Help request assignment methods
  openHelpRequestAssignment(helpRequest: any): void {
    this.selectedHelpRequest = helpRequest;
    this.helpRequestAssignments = {};
    this.helpRequestVehicles = {};
    this.loadingHelpRequestVehicles = {};
    
    // Initialize assignments and load vehicles for each item
    helpRequest.items.forEach((item: any) => {
      this.helpRequestAssignments[item.id] = {
        vehicleIds: []
      };
      this.loadingHelpRequestVehicles[item.id] = true;
      this.loadVehiclesForHelpRequestItem(item);
    });
  }

  private loadVehiclesForHelpRequestItem(item: any): void {
    const apiUrl = `/vehicles/free?vehicle_type=${item.vehicleType}`;
    
    this.apiService.get(apiUrl).subscribe({
      next: (response: any) => {
        this.helpRequestVehicles[item.id] = response.data || response;
        this.loadingHelpRequestVehicles[item.id] = false;
      },
      error: (error) => {
        console.error(`Error loading vehicles for type ${item.vehicleType}:`, error);
        this.helpRequestVehicles[item.id] = [];
        this.loadingHelpRequestVehicles[item.id] = false;
      }
    });
  }

  toggleVehicleSelection(helpRequestId: number, vehicleId: number): void {
    const assignment = this.helpRequestAssignments[helpRequestId];
    if (assignment) {
      const index = assignment.vehicleIds.indexOf(vehicleId);
      if (index > -1) {
        assignment.vehicleIds.splice(index, 1);
      } else {
        assignment.vehicleIds.push(vehicleId);
      }
    }
  }

  isVehicleSelected(helpRequestId: number, vehicleId: number): boolean {
    const assignment = this.helpRequestAssignments[helpRequestId];
    return assignment ? assignment.vehicleIds.includes(vehicleId) : false;
  }

  isVehicleSelectionDisabled(helpRequestId: number, vehicleId: number): boolean {
    const assignment = this.helpRequestAssignments[helpRequestId];
    if (!assignment || !this.selectedHelpRequest) return false;
    
    // Find the help request item
    const item = this.selectedHelpRequest.items.find((i: any) => i.id === helpRequestId);
    if (!item) return false;
    
    // If already selected, allow deselection
    if (assignment.vehicleIds.includes(vehicleId)) return false;
    
    // Check if reached the requested quantity limit
    return assignment.vehicleIds.length >= item.requestedQuantity;
  }

 

  assignVehiclesToHelpRequest(): void {
    if (!this.selectedHelpRequest) return;

    // Validate assignments
    const vehicleAssignments: any[] = [];
    let hasErrors = false;

    this.selectedHelpRequest.items.forEach((item: any) => {
      const assignment = this.helpRequestAssignments[item.id];
      if (assignment && assignment.vehicleIds.length > 0) {
        vehicleAssignments.push({
          helpRequestItemId: item.id,
          vehicleIds: assignment.vehicleIds
        });
      } else if (assignment && assignment.vehicleIds.length > 0) {
        hasErrors = true;
      }
    });

    if (hasErrors) {
      Swal.fire({
        icon: 'warning',
        title: 'Incomplete Assignment',
        text: 'Please select at least one vehicle for each help request item.',
        confirmButtonColor: '#B71C1C'
      });
      return;
    }

    if (vehicleAssignments.length === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Vehicles Selected',
        text: 'Please select at least one vehicle to assign.',
        confirmButtonColor: '#B71C1C'
      });
      return;
    }

    this.assigningHelpRequest = true;

    const requestData = {
      vehicleAssignments: vehicleAssignments,
      remarks: `Assigning vehicles to help request #${this.selectedHelpRequest.id}`
    };

    this.apiService.post(`/help-requests/${this.selectedHelpRequest.id}/assign-vehicles`, requestData).subscribe({
      next: (response: any) => {
        this.assigningHelpRequest = false;
        this.selectedHelpRequest = null;
        this.helpRequestAssignments = {};
        
        Swal.fire({
          icon: 'success',
          title: 'Vehicles Assigned Successfully!',
          text: 'The vehicles have been assigned to the help request.',
          confirmButtonColor: '#B71C1C'
        }).then(() => {
          this.loadIncidentData(); // Reload to update status
        });
      },
      error: (error) => {
        this.assigningHelpRequest = false;
        console.error('Error assigning vehicles to help request:', error);
        Swal.fire({
          icon: 'error',
          title: 'Assignment Failed',
          text: 'Failed to assign vehicles. Please try again.',
          confirmButtonColor: '#B71C1C'
        });
      }
    });
  }

  submitReinforcementRequest(): void {
    if (this.getTotalRequestedVehicles() === 0) {
      Swal.fire({
        icon: 'warning',
        title: 'No Vehicles Selected',
        text: 'Please specify at least one vehicle to request reinforcement.',
        confirmButtonColor: '#B71C1C'
      });
      return;
    }

    this.isSubmittingReinforcement = true;

    // Build vehicles array for API
    const vehicles: any[] = [];
    
    Object.keys(this.reinforcementRequest).forEach(key => {
      if (key !== 'remarks' && (this.reinforcementRequest[key] as number) > 0) {
        vehicles.push({
          vehicleType: key,
          quantity: this.reinforcementRequest[key] as number
        });
      }
    });

    // Get the first assignment ID for the incident
    const assignmentId = this.assignedVehicles.length > 0 ? this.assignedVehicles[0].id : null;

    const requestData = {
      incidentId: this.incidentId,
      assignmentId: assignmentId,
      vehicles: vehicles,
      description: this.reinforcementRequest['remarks'],
      sourceOfRequest: this.selectedRequestSource
    };

    this.apiService.post('/driver/request-additional-vehicles', requestData).subscribe({
      next: (response: any) => {
        this.isSubmittingReinforcement = false;
        
        // Close modal
        this.modalService.dismissAll();

        Swal.fire({
          icon: 'success',
          title: 'Reinforcement Request Submitted',
          text: `Your request for ${this.getTotalRequestedVehicles()} vehicle(s) has been submitted successfully.`,
          confirmButtonColor: '#B71C1C'
        });
      },
      error: (error) => {
        this.isSubmittingReinforcement = false;
        console.error('Error submitting reinforcement request:', error);
        Swal.fire({
          icon: 'error',
          title: 'Request Failed',
          text: 'Failed to submit reinforcement request. Please try again.',
          confirmButtonColor: '#B71C1C'
        });
      }
    });
  }
  
  openEditModal(): void {
    if (!this.incident) return;

    this.editData = {
      contactName: this.incident.contactName || '',
      contactNumber: this.incident.contactNumber || '',
      location: this.incident.location || '',
      landmark: this.incident.landmark || '',
      remarks: this.incident.remarks || ''
    };
    
    this.editModalRef = this.modalService.open(this.editIncidentModal, {
      size: 'md',
      backdrop: 'static',
      keyboard: false
    });
  }

  // Save updated incident details
  updateIncident(): void {
    this.updatingIncident = true;

    // Call the PUT API at /api/v1/incidents/:id
    this.apiService.put(`/incidents/${this.incidentId}`, this.editData).subscribe({
      next: (response: any) => {
        this.updatingIncident = false;
        
        // Update local incident data with new values
        if (this.incident) {
          this.incident.contactName = this.editData.contactName;
          this.incident.contactNumber = this.editData.contactNumber;
          this.incident.location = this.editData.location;
          this.incident.landmark = this.editData.landmark;
          this.incident.remarks = this.editData.remarks;
        }
        
        // Close modal
        if (this.editModalRef) {
          this.editModalRef.close();
        }
        
        Swal.fire({
          icon: 'success',
          title: 'Updated!',
          text: 'Incident details updated successfully.',
          confirmButtonColor: '#B71C1C'
        });
      },
      error: (error) => {
        this.updatingIncident = false;
        console.error('Error updating incident:', error);
        Swal.fire({
          icon: 'error',
          title: 'Update Failed',
          text: 'Failed to update incident. Please try again.',
          confirmButtonColor: '#B71C1C'
        });
      }
    });
  }

  openImagePopup(url: string): void {
    this.selectedImageUrl = url;
  }

  closeImagePopup(): void {
    this.selectedImageUrl = null;
  }
}
// Add global function for popup buttons
declare global {
  interface Window {
    selectFireStation: (stationId: number) => void;
    assignVehicleWithTanker: (vehicleId: number) => void;
  }
}
